export default __webpack_public_path__ + "static/media/emptyStateExchange.3b834c92.svg";